export default __webpack_public_path__ + "static/media/mlc-fundatia.821c4f40.jpeg";